<div class="row mb-2">
  <div class="col d-flex flex-direction-row justify-content-end">
    <lib-action-btn [config]="configService"></lib-action-btn>
  </div>
</div>
<div class="row">
  <div class="col">
    <lib-customer-list></lib-customer-list>
  </div>
</div>
